function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { injectIntl } from 'react-intl';
import isObjectLike from 'lodash/isObjectLike';
import intlShape from 'shapes/intlShape';
import UniformChoice from './partials/UniformChoice';
var _React_PureComponent;
class OptionBox extends (_React_PureComponent = React.PureComponent) {
    get isChecked() {
        return this.props.value === this.props.inputValue;
    }
    renderMessage(message) {
        if (!message) {
            return null;
        }
        if (isObjectLike(message) && !/*#__PURE__*/ React.isValidElement(message)) {
            return this.props.intl.formatMessage(message, _object_spread({}, message.values));
        }
        return message;
    }
    renderHeader() {
        const header = this.renderMessage(this.props.labelMessage);
        if (!header) {
            return null;
        }
        return /*#__PURE__*/ _jsx("h3", {
            className: "text--bold text-lh--133",
            children: header
        });
    }
    renderInfo() {
        const info = this.renderMessage(this.props.infoMessage);
        if (!info) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: "form-info mt-3",
            children: info
        });
    }
    renderContent() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderHeader(),
                this.renderInfo()
            ]
        });
    }
    render() {
        const id = `${this.props.id}-${this.props.inputValue}`;
        const { isChecked } = this;
        return /*#__PURE__*/ _jsx("label", {
            htmlFor: id,
            className: cn('form-control form-control--option-block', this.props.className, {
                'form-control--option-block-checked': isChecked,
                'form-control--option-block-disabled': this.props.isDisabled
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn('row', {
                    'flex-row-reverse align-items-center': this.props.isReverted
                }),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsx(UniformChoice, _object_spread_props(_object_spread({}, this.props), {
                            isRadio: true
                        }))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: this.renderContent()
                    })
                ]
            })
        });
    }
}
_define_property(OptionBox, "propTypes", {
    // Explicit props
    id: PropTypes.string,
    inputValue: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    labelMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element
    ]),
    infoMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element
    ]),
    isDisabled: PropTypes.bool,
    isReverted: PropTypes.bool,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    // Implicit props
    intl: intlShape.isRequired,
    // Explicit Actions
    onChange: PropTypes.func.isRequired
});
_define_property(OptionBox, "defaultProps", {
    id: '',
    value: '',
    isDisabled: false,
    className: ''
});
export default injectIntl(OptionBox);
